export const iconFontAwesomeHumanitarianSyringe = (
	<i className="fa-solid fa-syringe"></i>
);
